import {State} from "@progress/kendo-data-query"
import {GridColumnMenuFilter, GridColumnMenuProps} from "@progress/kendo-react-grid"


const filterEqOperator="grid.filterEqOperator"
const filterNotEqOperator="grid.filterNotEqOperator"
const filterOperators = {
    text: [
        {text: "grid.filterContainsOperator", operator: "contains"},
        {text: "grid.filterNotContainsOperator", operator: "doesnotcontain"},
        {text: filterEqOperator, operator: "eq"},
        {text: filterNotEqOperator, operator: "neq"},
        {text: "grid.filterStartsWithOperator", operator: "startswith"},
        {text: "grid.filterEndsWithOperator", operator: "endswith"},
    ],
    numeric: [
        {text: filterEqOperator, operator: "eq"},
        {text: filterNotEqOperator, operator: "neq"},
        {text: "grid.filterGteOperator", operator: "gte"},
        {text: "grid.filterGtOperator", operator: "gt"},
        {text: "grid.filterLteOperator", operator: "lte"},
        {text: "grid.filterLtOperator", operator: "lt"},
    ],
    date: [
        {text: filterEqOperator, operator: "eq"},
        {text: filterNotEqOperator, operator: "neq"},
        {text: "grid.filterAfterOrEqualOperator", operator: "gte"},
        {text: "grid.filterAfterOperator", operator: "gt"},
        {text: "grid.filterBeforeOperator", operator: "lt"},
        {text: "grid.filterBeforeOrEqualOperator", operator: "lte"},
    ],
    boolean: [{text: filterEqOperator, operator: "eq"}],
}

const isColumnActive = (field: string, dataState: State) => GridColumnMenuFilter.active(field, dataState.filter)

const ColumnMenu = (props: GridColumnMenuProps) => (
    <GridColumnMenuFilter {...props} hideSecondFilter={true} expanded={true} filterOperators={filterOperators} />
)

export const columnProps = (field: string, dataState: any) => ({
    field,
    columnMenu: ColumnMenu,
    headerClassName: isColumnActive(field, dataState) ? "active" : "",
})
export const columnextraProps = (
  field: string,
  dataState: any,
  extraHeaderClassName?: string
) => {
  const isActive = isColumnActive(field, dataState);
  return {
    field,
    columnMenu: ColumnMenu,
    headerClassName: [
      extraHeaderClassName,
      isActive ? "active" : ""
    ]
      .filter(Boolean)
      .join(" ")
  };
};